import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconArrowLeft = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-arrow-left" data-icon="icon-arrow-left" aria-hidden="true" {...props} ref={ref}><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>);
});

IconArrowLeft.displayName = 'IconArrowLeft';
